/*
 * GearFrost — Add-to-cart attention animation (ports Debutify's addtocart_animation).
 * Periodically toggles an animation class on the real product ATC button so it catches the
 * eye, then removes it so it can replay. Type + interval come from the section settings
 * (v1 hardcoded shake / 6s and ignored its own settings). Skipped entirely when the visitor
 * prefers reduced motion, while the tab is hidden, or while the button is disabled
 * (sold out / submitting).
 */
if (!customElements.get('gf-atc-animation')) {
  customElements.define(
    'gf-atc-animation',
    class GfAtcAnimation extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          return;
        }
        this.target = document.getElementById(this.dataset.target);
        if (!this.target) return;

        const type = (this.dataset.type || 'shake').trim();
        this.animClass = 'gf-atc-anim-' + type;
        const seconds = parseInt(this.dataset.interval, 10) || 6;
        this.intervalMs = Math.max(seconds, 2) * 1000;

        this.run = this.run.bind(this);
        this.timer = setInterval(this.run, this.intervalMs);
      }

      run() {
        if (document.hidden) return;
        if (this.target.hasAttribute('disabled')) return;
        this.target.classList.add(this.animClass);
        clearTimeout(this.clearTimer);
        this.clearTimer = setTimeout(() => {
          this.target.classList.remove(this.animClass);
        }, 1100);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.clearTimer);
      }
    }
  );
}
